import axios from 'axios'
import { axiosGet } from '../../shared/utils/apiUtils'
import {
  SelectionView,
  UpdateUserSettingsRequest,
  UserSettings,
} from '../profile/types'

export type SettingsResponse = {
  addressGroupIds: Array<string>
  timeTrackingDefaultProjectCostCenterSelectionView: SelectionView
  articleDialogDefaultSelectionView: SelectionView
}

const BASE_URL = 'v1/user/settings'

const getSettings = (): Promise<SettingsResponse> => axiosGet(BASE_URL)

export const updateUserSettings = async (
  updateUserProfileRequest: UpdateUserSettingsRequest
): Promise<UserSettings> => {
  const res = await axios.put<UserSettings>(BASE_URL, updateUserProfileRequest)
  return res.data
}

export { getSettings }
